export const enum VALID_WALLET_LINK_STATUSES {
    LINKED = 0,
    NEVER_LINKED = 1,
    TOKEN_EXPIRED = 2,
    RETRY = 3,
    BLOCKED = 4,
    BLACK_LISTED = 5,
    TRY_AFTER_SOME_TIME = 6,
    GENERIC_FAILURE = 7,
}

export const enum VALID_WALLET_TYPES {
    AMAZONPAY = "AMAZONPAY",
    FREECHARGE = "FREECHARGE",
    MOBIKWIK = "MOBIKWIK",
    PAYTM = "PAYTM",
    PHONEPE = "PHONEPE",
    AMAZONPAYWEB = "AMAZONPAYWEB",
}

export const ADD_MONEY_ELIGIBLE_WALLETS = [
    VALID_WALLET_TYPES.PAYTM,
    VALID_WALLET_TYPES.MOBIKWIK,
    VALID_WALLET_TYPES.FREECHARGE,
];

export const PHONEPE_PLACE_ORDER_TYPE_KEY = "phonepe_payment_type";

export const enum PHONEPE_PLACE_ORDER_TYPE {
    INSTANT_DEBIT = "INSTANT_DEBIT",
    REDIRECT = "REDIRECT",
    SDK = "SDK",
}

export const REDIRECT_SUPPORTED_WALLETS = [
    VALID_WALLET_TYPES.AMAZONPAY,
    VALID_WALLET_TYPES.PHONEPE,
    //TODO: need to revisit this
    VALID_WALLET_TYPES.AMAZONPAYWEB,
];

export const WALLET_OTP_LENGTH = {
    FREECHARGE: 4,
    "FREECHARGE-SSO": 4,
    MOBIKWIK: 6,
    "MOBIKWIK-SSO": 6,
    PAYLATER_LAZYPAY: 4,
    PAYTM: 6,
    PAYTM_POSTPAID: 6,
    "PAYTM-SSO": 6,
    PHONEPE: 5,
    "PHONEPE-SSO": 5,
};

//Link wallet page is being used on web-payments and payment-modes page, in web-payment wallet code is fetched
//from get-payment-methods api but on payment modes page no api call is made inorder to maintain consistency WALLET_CODES enum
//is created
export enum WALLET_CODES {
    paytm = "PayTM",
    paytmpostpaid = "PayTM_PostPaid",
    phonepe = "PhonePe",
    mobikwik = "Mobikwik",
    freecharge = "Freecharge",
    amazonpay = "AmazonPay",
    simpl = "PayLater_Simpl",
    mmt = "mmt",
}
